// Astrea Ops Platform - Rates by year (rate_cards table)
//
// 1 October 2026. One rate card per calendar year (see
// supabase/migrations/20261001000001_rate_cards_by_year.sql). The whole card the app
// uses lives in the `card` jsonb column; the original typed columns are filled too so
// nothing that reads them breaks. RLS: admin/finance only, same as every other
// financial table - other roles simply get no cards and the calculator falls back to
// built-in defaults (they cannot see prices anyway).

import { supabase } from './supabaseClient';

// Returns { [year]: card } for every saved year.
export async function loadRateCards() {
  const { data, error } = await supabase
    .from('rate_cards')
    .select('rate_year, card, updated_at')
    .not('rate_year', 'is', null);
  if (error) throw error;
  const byYear = {};
  (data || []).forEach(row => {
    if (row.card && Number.isInteger(row.rate_year)) byYear[row.rate_year] = { ...row.card, _updatedAt: row.updated_at };
  });
  return byYear;
}

export async function saveRateCard(year, card) {
  const { _updatedAt, ...clean } = card || {}; // eslint-disable-line no-unused-vars
  const row = {
    rate_year: year,
    card: clean,
    effective_from: `${year}-01-01`,
    attendee_tiers: clean.attendeeTiers || [],
    mm_pay: clean.mmPay ?? null,
    waves_fee: clean.wavesFee ?? null,
    writer_fee: clean.writerFee ?? null,
    pom_reviewer_fee: clean.pomReviewerFee ?? null,
    medical_rate: clean.medicalRate ?? null,
    mgmt_reserve_pct: clean.mgmtReservePct ?? null,
    training_sub_rate: clean.trainingSubRate ?? null,
    training_mm_rate: clean.trainingMmRate ?? null,
    updated_at: new Date().toISOString(),
  };
  const { error } = await supabase.from('rate_cards').upsert(row, { onConflict: 'rate_year' });
  if (error) throw error;
}
